import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c9f6e2d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-info-list" }
const _hoisted_2 = { class: "room-text" }
const _hoisted_3 = { class: "progress-bar-container" }
const _hoisted_4 = { class: "progress-bar" }
const _hoisted_5 = { class: "progress-text" }

import { AtomSubTitle } from '@/components/atoms';
import { withDefaults } from 'vue';

export interface CardListItem {
    label: string,
    value: number
}

interface IProps {
    title: string
    items: CardListItem[]
    gap?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MoleculeCardList',
  props: {
    title: {},
    items: {},
    gap: {}
  },
  setup(__props: any) {

const props = __props;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(AtomSubTitle), {
      class: "card-info-title",
      text: _ctx.title,
      "no-margin": true
    }, null, 8, ["text"]),
    _createElementVNode("div", {
      class: "container-list",
      style: _normalizeStyle({marginTop: _ctx.gap})
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.label
        }, [
          _createElementVNode("label", _hoisted_2, _toDisplayString(item.label) + ":", 1),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", {
                class: "progress-fill",
                style: _normalizeStyle({width: `${item.value}%`})
              }, null, 4)
            ]),
            _createElementVNode("span", _hoisted_5, _toDisplayString(item.value) + "%", 1)
          ])
        ]))
      }), 128))
    ], 4)
  ]))
}
}

})